import { RiFunctionFill, RiFunctionLine } from '@remixicon/react'
import {
  Perm_CarType_View,
  Perm_Currency_View,
  Perm_Location_View,
  Perm_OrderType_View,
  Perm_PaymentMethod_View,
  Perm_ShellType_View,
  Perm_ShippingLine_View,
  Perm_StaffType_View,
  PermALL
} from '../../app/hooks/premissionScreen'
import { createCollapseGroup, createItem } from '../../help'
import ROUTES from '../../routers/helpersRouter/constantRouter'
import { MenuItem } from '../../types'

const icons = {
  RiFunctionLine,
  RiFunctionFill
}

export const categoryMenuItem: MenuItem[] = [
  createCollapseGroup({
    id: 'list-category',
    title: 'Quản lý danh mục',
    icon: icons.RiFunctionLine,
    iconActive: icons.RiFunctionFill,
    premissions: PermALL,
    children: [
      createItem({
        id: 'category-shell-type',
        title: 'Loại hình đóng gói',
        url: `/${ROUTES.CATEGORY}/${ROUTES.CATEGORY_CHILD.SHELL_TYPE}`,
        premissions: Perm_ShellType_View
      }),
      createItem({
        id: 'category-car-type',
        title: 'Phương tiện',
        url: `/${ROUTES.CATEGORY}/${ROUTES.CATEGORY_CHILD.CAR_TYPE}`,
        premissions: Perm_CarType_View
      }),
      createItem({
        id: 'category-shipping-lines',
        title: 'Hãng tàu',
        url: `/${ROUTES.CATEGORY}/${ROUTES.CATEGORY_CHILD.SHIPPING_LINES}`,
        premissions: Perm_ShippingLine_View
      }),
      createItem({
        id: 'category-location',
        title: 'Địa điểm',
        url: `/${ROUTES.CATEGORY}/${ROUTES.CATEGORY_CHILD.LOCATION}`,
        premissions: Perm_Location_View
      }),
      createItem({
        id: 'category-currency',
        title: 'Tiền tệ',
        url: `/${ROUTES.CATEGORY}/${ROUTES.CATEGORY_CHILD.CURRENCY}`,
        premissions: Perm_Currency_View
      }),
      createItem({
        id: 'category-order-type',
        title: 'Loại hình đơn hàng',
        url: `/${ROUTES.CATEGORY}/${ROUTES.CATEGORY_CHILD.ORDER_TYPE}`,
        premissions: Perm_OrderType_View
      }),
      createItem({
        id: 'category-staff-type',
        title: 'Loại nhân viên',
        url: `/${ROUTES.CATEGORY}/${ROUTES.CATEGORY_CHILD.STAFF_TYPE}`,
        premissions: Perm_StaffType_View
      }),
      createItem({
        id: 'category-payment-method',
        title: 'Phương thức thanh toán',
        url: `/${ROUTES.CATEGORY}/${ROUTES.CATEGORY_CHILD.PAYMENT_METHOD}`,
        premissions: Perm_PaymentMethod_View
      })
    ]
  })
]
